import { render, staticRenderFns } from "./OperatoriComboMultiselect.vue?vue&type=template&id=424ef201&scoped=true"
import script from "./OperatoriComboMultiselect.vue?vue&type=script&lang=js"
export * from "./OperatoriComboMultiselect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424ef201",
  null
  
)

export default component.exports